import { Trans } from "@lingui/macro";
import { ColumnTitle } from "../ColumnTitle";
import { XIcon } from "@heroicons/react/outline";
import { Alert } from "components/UI/Alert/Alert";
import React, { useEffect, useState } from "react";
import { Loader } from "components/UI/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { NULL_VALUE } from "components/UI/SelectBox/SelectBox";
import { IdOrdersState } from "model/dashboardOrders/dOrdersReducer";
import { IdCategoriesStateDataItem } from "model/dashboardCategories/dCategoriesReducer";
import { dOrdersSetProductFiltersAC } from "model/dashboardOrders/dOrdersActionCreators";

export type typeCategories = {
  loader: boolean;
  categoryList: IdCategoriesStateDataItem[];
};

export const Categories: React.FC<typeCategories> = ({
  loader,
  categoryList,
}) => {
  const dispatch = useDispatch();

  const filters = useSelector(
    (state: { dOrders: IdOrdersState }) => state.dOrders.productsFilter,
  );
  const outOfCategories: IdCategoriesStateDataItem = {
    deleted: false,
    id: "outOfCategories",
    name: "Products without categories",
  };

  const [categorySelected, setCategorySelected] = useState<string | null>(
    filters?.category === undefined
      ? NULL_VALUE.id
      : filters.category === null
        ? outOfCategories.id
        : filters.category,
  );

  useEffect(() => {
    if (categorySelected !== NULL_VALUE.id) {
      dispatch(
        dOrdersSetProductFiltersAC({
          category:
            categorySelected === outOfCategories.id ? null : categorySelected,
        }),
      );
    }

    // eslint-disable-next-line
  }, [categorySelected]);

  // for clear selected category if search by name
  useEffect(() => {
    if (filters && !!filters.name) {
      setCategorySelected(NULL_VALUE.id);
    }
  }, [filters]);

  const onCategoriesClick = (id: string) => {
    setCategorySelected(id);
  };

  const onClearCategory = () => {
    setCategorySelected(NULL_VALUE.id);
  };

  return (
    <div className="flex flex-col gap-2 sm:gap-4 h-full">
      <ColumnTitle title={<Trans>Categories</Trans>} />
      <div className="flex-grow relative h-96">
        <div className="absolute inset-0 overflow-y-auto ">
          {categoryList.length ? (
            categoryList.map((item, index) => {
              return (
                <div
                  key={item.id}
                  className={`${
                    index % 2 === 0 ? "bg-gray-50 " : ""
                  }flex justify-between px-2 py-1 sm:px-4 sm:py-2 hover:bg-indigo-50 cursor-pointer rounded ${
                    categorySelected === item.id
                      ? " bg-indigo-500 hover:bg-indigo-500 text-white "
                      : ""
                  } `}
                >
                  <div
                    className={`flex-grow`}
                    onClick={() => onCategoriesClick(item.id)}
                  >
                    {item.id === "outOfCategories" ? (
                      <Trans>Out of categories</Trans>
                    ) : (
                      item.name
                    )}
                  </div>

                  <div
                    className={`${
                      categorySelected === item.id ? "block" : "hidden"
                    } flex align-center `}
                  >
                    <button
                      type="button"
                      className={`rounded-md text-indigo-50  hover:text-white transform transition-all hover:scale-110 focus:outline-none focus:ring-1  focus:ring-indigo-50`}
                      onClick={() => onClearCategory()}
                    >
                      <XIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              );
            })
          ) : (
            <Alert
              className="w-full"
              type={"info"}
              title={<Trans>The category list is empty.</Trans>}
            />
          )}
          {loader && <Loader />}
        </div>
      </div>
    </div>
  );
};
